import { endpoints, baseurl } from '../Utils/Constants';

export const getAllProviders = async (token) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDERS}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching providers:', error);
    throw error;
  }
};

export const getAllProviderSettings = async (token, type) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_SETTING}${type}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching prefixes:', error);
    throw error;
  }
};

export const saveProvider = async (token, providerData) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(providerData),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider:', error);
    throw error;
  }
};

export const getProviderById = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDERS_BY_ID}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider by ID:', error);
    throw error;
  }
};

export const saveProviderEducation = async (token, educationData) => {
  try {
    const { document, ...payload } = educationData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));

    if (document instanceof File) {
      formData.append('file', document);
    }

    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_EDUCATION}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider education:', error);
    throw error;
  }
};

export const getAllProviderEducations = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_EDUCATIONS}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider educations:', error);
    throw error;
  }
};

export const getProviderEducationById = async (token, educationId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_EDUCATION_BY_ID}${educationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider education by ID:', error);
    throw error;
  }
};

export const deleteProviderEducation = async (token, educationId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_EDUCATION}${educationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider education:', error);
    throw error;
  }
};

export const saveProviderExam = async (token, examData) => {
  try {
    const { document, ...payload } = examData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_EXAM}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider exam:', error);
    throw error;
  }
};

export const getAllProviderExams = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDERS_EXAMS}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider exams:', error);
    throw error;
  }
};

export const getProviderExamById = async (token, examId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_EXAM_BY_ID}${examId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider exam by ID:', error);
    throw error;
  }
};

export const deleteProviderExam = async (token, examId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_EXAM}${examId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider exam:', error);
    throw error;
  }
};

export const saveProviderEmployer = async (token, employerData) => {
  try {
    const { document, ...payload } = employerData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));

    if (document instanceof File) {
      formData.append('file', document);
    }

    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_EMPLOYER}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider employer:', error);
    throw error;
  }
};

export const getAllProviderEmployers = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_EMPLOYERS}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider employers:', error);
    throw error;
  }
};

export const getProviderEmployerById = async (token, employerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_EMPLOYER_BY_ID}${employerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider employer by ID:', error);
    throw error;
  }
};

export const deleteProviderEmployer = async (token, employerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_EMPLOYER}${employerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider employer:', error);
    throw error;
  }
};

export const saveProviderFacility = async (token, facilityData) => {
  try {
    const { document, ...payload } = facilityData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_FACILITY}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider facility:', error);
    throw error;
  }
};

export const getAllProviderFacilities = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_FACILITIES}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider facilities:', error);
    throw error;
  }
};

export const getProviderFacilityById = async (token, facilityId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_FACILITY_BY_ID}${facilityId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider facility by ID:', error);
    throw error;
  }
};

export const deleteProviderFacility = async (token, facilityId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_FACILITY}${facilityId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider facility:', error);
    throw error;
  }
};

export const saveProviderWorkHistory = async (token, workHistoryData) => {
  try {
    const { document, ...payload } = workHistoryData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_WORK_HISTORY}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider work history:', error);
    throw error;
  }
};

export const getAllProviderWorkHistory = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_WORK_HISTORY}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider work history:', error);
    throw error;
  }
};

export const getProviderWorkHistoryById = async (token, workHistoryId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_WORK_HISTORY_BY_ID}${workHistoryId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider work history by ID:', error);
    throw error;
  }
};

export const deleteProviderWorkHistory = async (token, workHistoryId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_WORK_HISTORY}${workHistoryId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider work history:', error);
    throw error;
  }
};

export const saveProviderMilitary = async (token, militaryData) => {
  try {
    const { document, ...payload } = militaryData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_MILITARY}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider military experience:', error);
    throw error;
  }
};

export const getAllProviderMilitary = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_MILITARY}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider military experience:', error);
    throw error;
  }
};

export const getProviderMilitaryById = async (token, militaryId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_MILITARY_BY_ID}${militaryId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider military experience by ID:', error);
    throw error;
  }
};

export const deleteProviderMilitary = async (token, militaryId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_MILITARY}${militaryId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider military experience:', error);
    throw error;
  }
};

export const saveProviderPeerReference = async (token, peerReferenceData) => {
  try {
    const { document, ...payload } = peerReferenceData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_PEER_REFERENCE}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider peer reference:', error);
    throw error;
  }
};

export const getAllProviderPeerReferences = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_PEER_REFERENCE}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider peer references:', error);
    throw error;
  }
};

export const getProviderPeerReferenceById = async (token, peerReferenceId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_PEER_REFERENCE_BY_ID}${peerReferenceId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider peer reference by ID:', error);
    throw error;
  }
};

export const deleteProviderPeerReference = async (token, peerReferenceId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_PEER_REFERENCE}${peerReferenceId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider peer reference:', error);
    throw error;
  }
};

export const saveProviderHealthInfo = async (token, healthInfoData) => {
  try {
    const { document, ...payload } = healthInfoData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_HEALTH_INFO}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider health info:', error);
    throw error;
  }
};

export const getAllProviderHealthInfo = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_HEALTH_INFO}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider health info:', error);
    throw error;
  }
};

export const getProviderHealthInfoById = async (token, healthInfoId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_HEALTH_INFO_BY_ID}${healthInfoId}`, {  
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider health info by ID:', error);
    throw error;
  }
};

export const deleteProviderHealthInfo = async (token, healthInfoId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_HEALTH_INFO}${healthInfoId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider health info:', error);
    throw error;
  }
};

export const saveProviderMalpracticeInfo = async (token, malpracticeData) => {
  try {
    const { document, ...payload } = malpracticeData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_MALPRACTICE}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider malpractice info:', error);
    throw error;
  }
};

export const getAllProviderMalpracticeInfo = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_MALPRACTICE}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider malpractice info:', error);
    throw error;
  }
};

export const getProviderMalpracticeInfoById = async (token, malpracticeInfoId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_MALPRACTICE_BY_ID}${malpracticeInfoId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider malpractice info by ID:', error);
    throw error;
  }
};

export const deleteProviderMalpracticeInfo = async (token, malpracticeInfoId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_MALPRACTICE}${malpracticeInfoId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider malpractice info:', error);
    throw error;
  }
};

export const saveProviderEventLog = async (token, eventLogData) => {
  try {
    const formData = new FormData();
    formData.append('request', JSON.stringify(eventLogData));

    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_EVENT_LOG}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider event log:', error);
    throw error;
  }
};

export const getAllProviderEventLogs = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_EVENT_LOG}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider event logs:', error);
    throw error;
  }
};

export const getProviderEventLogById = async (token, eventLogId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_EVENT_LOG_BY_ID}${eventLogId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider event log by ID:', error);
    throw error;
  }
};

export const deleteProviderEventLog = async (token, eventLogId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_EVENT_LOG}${eventLogId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider event log:', error);
    throw error;
  }
};

export const saveProviderLicense = async (token, licenseData) => {
  try {
    const { document, ...payload } = licenseData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_LICENSE}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider license:', error);
    throw error;
  }
};

export const getProviderLicenseById = async (token, licenseId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_LICENSE_BY_ID}${licenseId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider license by ID:', error);
    throw error;
  }
};

export const getAllProviderStateLicenses = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_STATE_LICENSES}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider state licenses:', error);
    throw error;
  }
};

export const getAllProviderDEALicenses = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_DEAL_LICENSES}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider DEA licenses:', error);
    throw error;
  }
};

export const getAllProviderControlledSubstanceLicenses = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_CONTROLLED_SUBSTANCE_LICENSES}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider controlled substance licenses:', error);
    throw error;
  }
};

export const deleteProviderLicense = async (token, licenseId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_LICENSE}${licenseId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider license:', error);
    throw error;
  }
};

export const saveProviderCertificates = async (token, certificateData) => {
  try {
    const { document, ...payload } = certificateData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_PROVIDER_CERTIFICATES}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving provider certificate:', error);
    throw error;
  }
};

export const getAllProviderBoardCertificates = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_BOARDS}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider board certificates:', error);
    throw error;
  }
};

export const getAllProviderProfessionalCertificates = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_PROFESSIONAL}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider professional certificates:', error);
    throw error;
  }
};

export const getAllProviderAdditionalCertificates = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_ADDITIONAL}${providerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider additional certificates:', error);
    throw error;
  }
};

export const getProviderCertificateById = async (token, certificateId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_CERTIFICATES_BY_ID}${certificateId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider certificate by ID:', error);
    throw error;
  }
};

export const deleteProviderCertificate = async (token, certificateId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER_CERTIFICATES}${certificateId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider certificate:', error);
    throw error;
  }
};

const convertDataUriToBlob = (dataUri) => {
  const [meta, base64] = dataUri.split(',');
  const matches = meta.match(/data:([^;]+);base64/i);
  const mimeType = matches ? matches[1] : 'application/octet-stream';
  const binary = atob(base64);
  const length = binary.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
};

export const previewProviderFile = async (token, fileId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.PREVIEW_PROVIDER_FILE}${fileId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    const contentDisposition = response.headers.get('content-disposition') || '';

    if (!response.ok) {
      if (contentType.includes('application/json')) {
        const err = await response.json();
        throw err;
      }
      throw new Error(`Failed to preview file: ${response.status}`);
    }

    if (contentType.includes('application/json')) {
      const result = await response.json();
      const payload = result?.data || result;
      const dataUri = payload?.data_uri || payload?.dataUri;
      const dataString = typeof payload?.data === 'string' ? payload.data : null;
      const filename = payload?.file_name || payload?.filename || result?.file_name || result?.filename || '';

      if (dataUri) {
        const blob = convertDataUriToBlob(dataUri);
        if (!blob.type.toLowerCase().includes('pdf')) {
          throw new Error('Unable to preview this file type.');
        }
        return {
          blob,
          filename,
          contentType: blob.type,
        };
      }
      if (dataString) {
        const resolvedDataUri = dataString.startsWith('data:')
          ? dataString
          : `data:${payload.contentType || result.contentType || 'application/pdf'};base64,${dataString}`;
        const blob = convertDataUriToBlob(resolvedDataUri);
        if (!blob.type.toLowerCase().includes('pdf')) {
          throw new Error('Unable to preview this file type.');
        }
        return {
          blob,
          filename,
          contentType: blob.type,
        };
      }
      return result;
    }

    const arrayBuffer = await response.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer.slice(0, 5));
    const header = new TextDecoder().decode(bytes);
    const filename = (() => {
      const fnMatch = /filename\*?=(?:UTF-8''?)?"?([^";]+)"?/.exec(contentDisposition);
      if (!fnMatch) {
        return '';
      }
      try {
        return decodeURIComponent(fnMatch[1]);
      } catch (e) {
        return fnMatch[1];
      }
    })();

    const isPdf = contentType.includes('pdf') || filename.toLowerCase().endsWith('.pdf') || header === '%PDF-';
    if (!isPdf) {
      throw new Error('Preview unavailable for this file type.');
    }

    const blob = new Blob([arrayBuffer], { type: contentType || 'application/pdf' });
    return { blob, filename, contentType };
  } catch (error) {
    console.error('Error previewing provider file:', error);
    throw error;
  }
};

export const downloadProviderFile = async (token, fileId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DOWNLOAD_PROVIDER_FILE}${fileId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    const contentDisposition = response.headers.get('content-disposition') || '';

    if (!response.ok) {
      if (contentType.includes('application/json')) {
        const err = await response.json();
        throw err;
      }
      throw new Error(`Failed to download file: ${response.status}`);
    }

    if (contentType.includes('application/json')) {
      const result = await response.json();
      const payload = result?.data || result;
      const dataUri = payload?.data_uri || payload?.dataUri;
      const dataString = typeof payload?.data === 'string' ? payload.data : null;
      const filename = payload?.file_name || payload?.filename || result?.file_name || result?.filename || '';

      if (dataUri) {
        const blob = convertDataUriToBlob(dataUri);
        return {
          blob,
          filename,
          contentType: blob.type,
        };
      }
      if (dataString) {
        const resolvedDataUri = dataString.startsWith('data:')
          ? dataString
          : `data:${payload.contentType || result.contentType || 'application/pdf'};base64,${dataString}`;
        const blob = convertDataUriToBlob(resolvedDataUri);
        return {
          blob,
          filename,
          contentType: blob.type,
        };
      }
      return result;
    }

    const blob = await response.blob();
    let filename = '';
    const fnMatch = /filename\*?=(?:UTF-8''?)?"?([^";]+)"?/.exec(contentDisposition);
    if (fnMatch) {
      try {
        filename = decodeURIComponent(fnMatch[1]);
      } catch (e) {
        filename = fnMatch[1];
      }
    }

    return { blob, filename, contentType };
  } catch (error) {
    console.error('Error downloading provider file:', error);
    throw error;
  }
};


export const getAllProviderNames = async (token, clientId) => {
  try {
    const query = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_PROVIDER_NAMES}${query}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider names:', error);
    throw error;
  }
};

export const getAllHealthcarePayors = async (token) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_HEALTHCARE_PAYORS}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching healthcare payors:', error);
    throw error;
  }
};

export const getHealthcarePayorById = async (token, payorId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_HEALTHCARE_PAYOR_BY_ID}${payorId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching healthcare payor by ID:', error);
    throw error;
  }
};

export const saveHealthcarePayor = async (token, payorData) => {
  try {
    const { document, ...payload } = payorData;
    const formData = new FormData();
    formData.append('request', JSON.stringify(payload));
    if (document instanceof File) {
      formData.append('file', document);
    }
    const response = await fetch(`${baseurl}${endpoints.SAVE_HEALTHCARE_PAYOR}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving healthcare payor:', error);
    throw error;
  }
};

export const deleteHealthcarePayor = async (token, payorId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_HEALTHCARE_PAYOR}${payorId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting healthcare payor:', error);
    throw error;
  }
};

export const getAllHealthCareNotes = async (token, healthcarePayorId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_ALL_HEALTHCARE_NOTES}${healthcarePayorId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching healthcare notes:', error);
    throw error;
  }
};

export const saveHealthcareNote = async (token, noteData) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.SAVE_HEALTHCARE_NOTES}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(noteData),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving healthcare note:', error);
    throw error;
  }
};

export const deleteProvider = async (token, providerId) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.DELETE_PROVIDER}${providerId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error deleting provider:', error);
    throw error;
  }
};

export const getProviderDetailByNPI = async (token, npi) => {
  try {
    const response = await fetch(`${baseurl}${endpoints.GET_PROVIDER_NPI}${npi}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching provider detail by NPI:', error);
    throw error;
  }
};
